export default __webpack_public_path__ + "static/media/photo--sm--group-jump.3a128135.jpg";